module.exports = __webpack_public_path__ + "img/5f.c5addd74.png";